'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Mustache = _interopDefault(require('mustache'));

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/**
 * A Toast manager -- only for DOM project
 * @author Samuel
 */

var Toast = function () {
  /**
   * Creates an instance of Toast.
   * @memberof Toast
   */
  function Toast() {
    classCallCheck(this, Toast);

    /**
     * Default toast template
     * @member {string} template
     */
    this.template = '<div style="padding: 15px 5px; margin: 0 auto; min-width: 100px; max-width: 300px; background-color: rgba(0,0,0,.6); border-radius: 5px; text-align: center; color: #fff">\n                      <p style="margin: 0; word-break: break-all;">{{ message }}</p>\n                    </div>';

    /**
     * Default data
     * @member {object} data
     */
    this.data = {
      message: 'I am a toast!'

      /**
       * Save trashes of toasts and styleSheets, it will be use in destroy methods to correctly remove toasts on show and style elements.
       * @member {object} trash
       */
    };this.trash = {
      toastList: [],
      styleSheets: []

      /**
       * A symbol link to a styleSheets
       * @member {null|HTMLStyleDocument} style
       */
    };this.style = null;
  }

  /**
   * For install in Vue
   * 
   * @param {any} v 
   * @param {any} options 
   * @memberof Toast
   */


  createClass(Toast, [{
    key: 'install',
    value: function install(v, options) {
      options = options || {};
      v.prototype.$toast = this;

      this._handleOptions(options);
    }

    /**
     * Now just support template
     * 
     * @param {any} op 
     * @memberof Toast
     */

  }, {
    key: '_handleOptions',
    value: function _handleOptions(op) {
      this.template = op.template || this.template;
    }

    /**
     * To create a styleSheet for toast animation
     * 
     * @memberof Toast
     */

  }, {
    key: '_prepareAnimations',
    value: function _prepareAnimations() {
      this.style = document.createElement('style');

      this.style.innerHTML = this._createAnimationContext();

      document.head.appendChild(this.style);
      this.trash.styleSheets.push(this.style);
    }

    /**
     * Build the style context according to top or bottom arguments. When top passed in, Toast will ignore the bottom value
     * 
     * @returns style context
     * @memberof Toast
     */

  }, {
    key: '_createAnimationContext',
    value: function _createAnimationContext() {
      if (this.top && !this.bottom) {
        return ('\n        @keyframes slideInTop {\n          from {top: -100px}\n          to {top: ' + this.top + 'px}\n        }\n\n        @keyframes slideOutTop {\n          from {top: ' + this.top + 'px}\n          to {top: -100px}\n        }\n      ').replace('<br>', '');
      }

      return ('\n      @keyframes slideInBottom {\n        from {bottom: -100px}\n        to {bottom: ' + this.bottom + 'px}\n      }\n\n      @keyframes slideOutBottom {\n        from {bottom: ' + this.bottom + 'px}\n        to {bottom: -100px}\n      }\n    ').replace('<br>', '');
    }

    /**
     * Create a toast wrapper, animation works on it
     * 
     * @returns wrapper of a toast
     * @memberof Toast
     */

  }, {
    key: '_createWrapper',
    value: function _createWrapper() {
      this.wrapper = document.createElement('div');
      this.wrapper.type = this.top ? 'Top' : 'Bottom';

      var wrapper = this.wrapper;
      wrapper.style.position = 'fixed';
      wrapper.style.left = '0';
      wrapper.style.right = '0';
      wrapper.style.margin = '0 auto';
      wrapper.style.width = 'auto';
      wrapper.style.zIndex = '9999';

      if (this.top) {
        wrapper.style.top = this.top + 'px';
      } else {
        // Give a default value to bottom if no top and bottom at same time
        wrapper.style.bottom = (this.bottom || 100) + 'px';
      }

      wrapper.style.animation = 'slideIn' + wrapper.type + ' 300ms';

      this.trash.toastList.push(wrapper);

      return wrapper;
    }

    /**
     * Render toast with data, use mustache to render the template
     * 
     * @param {any} data 
     * @memberof Toast
     */

  }, {
    key: '_render',
    value: function _render(data) {
      console.log('what');
      this._prepareAnimations();

      var wrapper = this._createWrapper(null),
          frag = document.createDocumentFragment();
      wrapper.innerHTML = Mustache.render(this.template, data);
      frag.appendChild(wrapper);

      document.body.appendChild(frag);
    }

    /**
     * Destroy toast and its styleSheets after display in keep time.
     * 
     * @memberof Toast
     */

  }, {
    key: '_destroy',
    value: function _destroy() {
      var _this = this;

      setTimeout(function () {
        var toastTrash = _this.trash.toastList.shift(),
            styleTrash = _this.trash.styleSheets.shift();
        toastTrash.style.animation = 'slideOut' + toastTrash.type + ' 300ms';
        toastTrash.addEventListener('animationend', function () {
          document.body.removeChild(toastTrash);
          document.head.removeChild(styleTrash);
        });
      }, this.keep);
    }

    /**
     * Message is essential, if there's no top or bottom, _createWrapper will gives a default bottom value
     * 
     * @param {any} conf 
     * @memberof Toast
     */

  }, {
    key: 'show',
    value: function show(conf) {
      var top = conf.top,
          bottom = conf.bottom,
          keep = conf.keep,
          data = objectWithoutProperties(conf, ['top', 'bottom', 'keep']);


      this.data = data;
      this.top = top;
      this.bottom = bottom;
      this.keep = keep || 2000;
      this._render(data);
      this._destroy();
    }
  }]);
  return Toast;
}();

module.exports = Toast;
